export function getImage(type) {
  switch (parseInt(type)) {
    case 1:
    case 2:
      return require("../assets/icons/vertical_tank.svg");
    case 3:
      return require("../assets/icons/horizontal_tank.svg");
    case 4:
      return require("../assets/icons/tanker_truck.svg");
    case 5:
      return require("../assets/icons/railway_tank.svg");
    case 6:
      return require("../assets/icons/tanker_truck.svg");
    case 7:
      return require("../assets/icons/railway_tank.svg");
    case 11:
    case 12:
    case 13:
      return require("../assets/icons/pressurized_apparatus.svg");
    case 31:
    case 32:
    case 33:
      return require("../assets/icons/pump.svg");
    case 21:
    case 22:
    case 23:
      return require("../assets/icons/GRK_TRK.svg");
    case 14:
    case 15:
    case 16:
      return require("../assets/icons/ball_tank.svg");
    case 17:
    case 19:
      return require("../assets/icons/technological_turbine.svg");
    case 41:
    case 42:
    case 43:
      return require("../assets/icons/pipelines.svg");
    case 44:
      return require("../assets/icons/technological_turbine.svg");
    case 45:
    case 46:
      return require("../assets/icons/pipelines.svg");
    case 51:
      return require("../assets/icons/chemical_reactor.svg");
    case 34:
      return require("../assets/icons/gas_candle.svg");
    default:
      return require("../assets/icons/vertical_tank.svg");
  }
}

export function handleInstallationDropdownClick(event, distance = 240) {
  const distanceToBottom = window.innerHeight - event.clientY;
  const yOffset = distanceToBottom < distance ? distance - distanceToBottom : 0;

  return -yOffset;
}

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
}

export function scrollToErrorInput(errors, ref) {
  if (Object.keys(errors).length > 0) {
    const firstErrorInput = ref[Object.keys(errors)[0]];
    if (firstErrorInput) {
      firstErrorInput.focus();
      firstErrorInput.scrollIntoView({ behavior: "smooth" });
    }
  }
}
